import gql from 'graphql-tag';

export const chimeraUserInformationQuery = gql`
  query getUserInformation {
    chimera {
      me {
        name
        firstName
        lastName
        roles {
          name
        }
        settings {
          experiments {
            migrationToClassroomsEnabled
          }
        }
        featureFlags(
          names: [
            "redirect-to-classrooms"
            "postgrad-assessments-card"
            "postgrad-tcc"
            "social-metaverse"
            "new-terms-update-dialog"
            "public-video-notes"
            "undergrad-classrooms-grades"
            "equal-web-accessibility-widget"
            "rename-periods-to-modules"
            "undergrad-classrooms-due-date-warning"
            "grade-activities-via-ai"
            "postgrad-contract-extension"
            "postgrad-students-documents"
            "postgrad-course-certificate"
            "postgrad-trial"
          ]
        )
        pictureSHA
        courses {
          _id
          slug
          name
          dexCourseId
          shouldRedirectToClassrooms
          dexCourseAvailability
          category {
            slug
            name
          }
          contractByUser {
            id
            startDate
            expirationDate
          }
        }
        expiredCourses {
          _id
          slug
          name
          dexCourseId
          shouldRedirectToClassrooms
          dexCourseAvailability
          category {
            slug
            name
          }
          expiredContractsByUser {
            id
            startDate
            expirationDate
          }
        }
      }
    }
  }
`;

export const chimeraCourseSupportMaterialFilesQuery = gql`
  query getCourseSupportMaterialFiles($courseId: String) {
    chimera {
      course(_id: $courseId) {
        supportMaterialFolders {
          title
          description
          supportMaterials {
            title
            s3URL
            sequence
            description
          }
        }
      }
    }
  }
`;
